<template>
    <div class="orderTabItem">
        <b-row class="content service-report-card">
            <b-col md="12">
                <group-service-report></group-service-report>
            </b-col>    
            <!-- <b-col md="12">
                <gofix-card title="action taken" class="fixHeight">
                    <template slot="gofixCard:right_header">
                        <template v-if="!IsReadOnly">
                            <button class="icon-button"
                                v-if="$checkRole(this.$accessModule.order_tabs.service_report, 'update')"
                                @click="editActionTaken"><img width="20" src="img/iconPencil.png" alt="" /></button>
                        </template>
                    </template>
                    <b-row>
                        <b-col md="12" class="mb-3">
                            <gofix-text-field label="description" oneline>
                                <span v-html="Item.action_taken ? Item.action_taken.description.replaceAll('\n', '<br>') : ''"></span>
                            </gofix-text-field>
                        </b-col>
                        <b-col md="12" class="photosThumb mt-0">
                            <gofix-text-field label="photos" oneline>
                                <template v-if="Item.action_taken">
                                    <viewer-image :images="Item.action_taken.attachments">
                                        <template slot="gofixViewer:list_image" ref="viewerFinding" slot-scope="{images}">
                                            <ul class="list-thumb">
                                               <li v-for="(item, key) in images" :class="{'d-none': key > 4}" v-bind:key="key">
                                                    <img v-auth-image="item.url.original" :alt="item.image_file_name" :key="item.url.original"  src="img/loading.gif">
                                                    <span class="pointer-event-none font-weight-bold" v-if="images.length > 5 && key == 4">+{{ images.length-5 }}</span>
                                                </li>
                                            </ul>
                                        </template>
                                    </viewer-image>
                                </template>
                            </gofix-text-field>
                        </b-col>
                    </b-row>
                </gofix-card>
            </b-col>
            <b-col md="12">
                <work-findings></work-findings>
            </b-col> -->
            <b-col md="12">
                <gofix-card title="Signatures" classHeader="mb-13" classContent="mb-0" v-if="Item.signatures.length">
                    <b-row no-gutters class="mb-15">
                        <template v-for="(item, index) in Item.signatures">
                            <b-col md="4" class="pr-15" :key="index">
                                <gofix-card class="pd-20" classContent="pd-0">
                                    <b-row>
                                        <b-col md="6">
                                            <gofix-text-field label="User" oneline>{{ item.name ? item.name : (item.user && item.user.name) ? item.user.name : '-' }}</gofix-text-field>
                                        </b-col>
                                        <b-col md="6">
                                            <gofix-text-field label="Signature" class="photosThumb mt-0" classInner="justify-content-end" oneline>
                                                <template v-if="item.attachments">
                                                    <viewer-image :images="item.attachments" classViewer='d-flex align-items-center'>
                                                        <template slot="gofixViewer:list_image" ref="viewerFinding" slot-scope="{images}">
                                                            <ul class="list-thumb signature_v2">
                                                                <template v-for="(item_image, key) in images">
                                                                    <li :key="key">
                                                                        <img v-auth-image="item_image.url.original" :alt="item_image.image_file_name" :key="item_image.url.original" src="img/loading.gif">
                                                                    </li>
                                                                </template>
                                                            </ul>
                                                        </template>
                                                    </viewer-image>
                                                </template>
                                            </gofix-text-field>
                                        </b-col>
                                    </b-row>
                                </gofix-card>
                            </b-col>
                        </template>
                    </b-row>
                </gofix-card>
            </b-col>
            <b-col md="12" v-if="Item.order_status === 'Cancelled' && Item.order_cancellation">
                <gofix-card title="Cancellation" class="">
                    <template slot="gofixCard:right_header">
                        <button class="icon-button" @click="openCancellationModal"><img width="20" src="img/iconPencil.png" alt="" /></button>
                    </template>
                    <b-row>
                        <b-col md="3">
                            <gofix-text-field label="Reason For Cancellation" oneline>{{Item.order_cancellation.reasons ? Item.order_cancellation.reasons.reference_value_text : ''}}</gofix-text-field>
                        </b-col>
                        <b-col md="3">
                            <gofix-text-field label="Remark" oneline>{{Item.order_cancellation.remark}}</gofix-text-field>
                        </b-col>
                        <b-col md="6" class="attachmentsColumn service-report mt-0">
                            <gofix-text-field label="Attachments" oneline>
                                <template v-if="Item.order_cancellation && Item.order_cancellation.attachments">
                                    <viewer-image :images="Item.order_cancellation.attachments" :showImage="false">
                                        <template slot="gofixViewer:list_image" slot-scope="{images}">
                                            <template v-for="attachment in images">
                                                <div class="item" v-if="attachment.id">
                                                    <div class="item-content position-relative" @click="previewFile(attachment)">
                                                        <span class="icon" v-html="$options.filters.iconFile(attachment, icons, true)"></span>
                                                        <span class="name">{{attachment.image_file_title || attachment.image_file_name || attachment.name}}</span>
                                                        <!-- <img class="image-viewer" v-if="checkShowImage(attachment.image_content_type)" v-auth-image="attachment.url.original" :key="attachment.url.original" src="img/loading.gif"> -->
                                                    </div>
                                                </div>
                                            </template>
                                        </template>
                                    </viewer-image>
                                </template>
                            </gofix-text-field>
                        </b-col>
                    </b-row>
                </gofix-card>
            </b-col>
        </b-row>
        <b-row v-if="Item.order_type === 'PWO'">
            <b-col md="12">
                <gofix-card title="job list" class="mb-0" classContent="mb-0" fullContent>
                    <template slot="gofixCard:right_header">
                        <span class="percentComplete">{{OrderJobList.data | countCompleted}}/{{OrderJobList.data.length}} DONE</span>
                    </template>
                    <div class="contentPadding mb-3">
                        <b-row>
                            <b-col>
                                <gofix-text-field label="checklist" oneline>Monthly service</gofix-text-field>
                            </b-col>
                            <b-col>
                                <gofix-text-field label="equipment group" oneline>{{(OrderJobList.data.length && OrderJobList.data[0].equipment_type) ? OrderJobList.data[0].equipment_type.name : ""}}</gofix-text-field>
                            </b-col>
                            <b-col>
                                <gofix-text-field label="supplier" oneline>{{OrderJobList.data.length ? OrderJobList.data[0].supplier : ""}}</gofix-text-field>
                            </b-col>
                            <b-col>
                                <gofix-text-field label="frequency" oneline>{{(OrderJobList.data.length && OrderJobList.data[0].maintenance_schedule &&  OrderJobList.data[0].maintenance_schedule.get_sor_recurring_mode) ? OrderJobList.data[0].maintenance_schedule.get_sor_recurring_mode.recurring_mode : ""}}</gofix-text-field>
                            </b-col>
                        </b-row>
                    </div>
                    <gofix-table 
                        :settings="tableConfig"
                        :table-items="tableItems"
                        @load-items="getTableData"
                        class="service-report-job-list noFullHeight scrollAbsolute"
                        ref="gofixTable">
                        <template slot="gofix_table:planned_date" slot-scope="row">
                            {{ row.item.planned_date | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY") }}
                        </template>
                        <template slot="gofix_table:expiry_date" slot-scope="row">
                            {{ row.item.expiry_date | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY") }}
                        </template>
                        <template slot="gofix_table:tag_name" slot-scope="row">
                            {{row.item.equipment ? row.item.equipment.tag_name : "N/A"}}
                        </template>
                        <template slot="gofix_table:name_checklist" slot-scope="row">
                            <router-link :to="{ name: 'job-checklist', params: { id: row.item.id } }" class="custom-link text-decoration-underline">
                                {{ (row.item.checklists != null && row.item.checklists.name_checklist) ? row.item.checklists.name_checklist : 'N/A' }}
                            </router-link>
                        </template>
                    </gofix-table>
                </gofix-card>
            </b-col>
        </b-row>
        <b-modal :no-close-on-backdrop="true" id="modal-Create" title="action taken" hide-footer :centered="true" ref="modal-edit-action-taken" @close="() => {
            this.action_taken_del_ids = [];
            this.imgActionTakenAction.photos = [];
        }">
            <b-form class="pb-10">
                <gofix-form-input-textarea label="Description" :rows="5" v-model="action_taken.description"></gofix-form-input-textarea>
                <b-form-group label="photos" class="photosThumb clear-both">
                    <ul class="list-thumb">
                        <li v-for="(item,key) in action_taken.attachments" v-bind:key="key"><img v-auth-image="item.url.thumb" src="img/loading.gif" alt="" > <span  class="delete" @click="deleteImgActionTaken(item)"><img src="img/close.png" alt=""></span></li>
                    </ul>
                    <div class="upload-btn-wrapper">
                        <b-form-file accept="image/jpeg, image/png, image/gif" id="fileInputMulti" v-model="imgActionTaken" :plain="true" :multiple="true"></b-form-file>
                        <gofix-button class="m-3" label="add photo" outline></gofix-button>
                    </div>
                </b-form-group>
            </b-form>
            <b-button-group class="d-block text-right">
                <!-- <gofix-button label="CANCEL" @click="$refs['modal-edit-action-taken'].hide()" noBorder dark></gofix-button> -->
                <gofix-button label="SUBMIT" @click="updateActionTaken" :loading="isAction" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Create" title="Work Findings" hide-footer :centered="true" ref="modal-edit-work-finding" @close="() => {
            this.work_finding_del_ids = [];
            this.imgWorkFindingAction.photos = [];
        }">
            <b-form class="pb-10">
                <gofix-form-input label="Description" v-model="work_finding.description"></gofix-form-input>
                <b-form-group label="photos" class="photosThumb clear-both">
                    <ul class="list-thumb">
                        <li v-for="(item,key) in work_finding.attachments" v-bind:key="key"><img v-auth-image="item.url.thumb" src="img/loading.gif" alt=""  > <span  class="delete" @click="deleteImgWorkFinding(item)"><img src="img/close.png" alt=""></span></li>
                    </ul>
                    <div class="upload-btn-wrapper">
                        <b-form-file accept="image/jpeg, image/png, image/gif" id="fileInputMulti" v-model="imgWorkFinding" :plain="true" :multiple="true"></b-form-file>
                        <gofix-button class="m-3" label="add photo" outline></gofix-button>
                    </div>
                </b-form-group>
            </b-form>
            <b-button-group class="d-block text-right">
                <!-- <gofix-button label="CANCEL" @click="$refs['modal-edit-work-finding'].hide()" noBorder dark></gofix-button> -->
                <gofix-button label="SUBMIT" @click="updateWorkFinding" :loading="isAction" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" ref="modalThumb" id="modalThumb" hide-footer>
            <view-img :Imgs="attachments_show_modal" ></view-img>
        </b-modal>
        <b-modal 
            :no-close-on-backdrop="true" 
            id="modal-Create" 
            size="lg"
            title="Cancellation"
            hide-footer
            :centered="true"
            v-model="modals.cancellation.open">
            <b-row>
                <b-col>
                    <b-form class="formV2" v-bind:class="{'run-loading':modals.cancellation.loading}">
                        <gofix-form-dropdown
                            label="Order Status"
                            v-model="Item.order_status"
                            disabled=""
                            :options="[]">
                        </gofix-form-dropdown>
                        <gofix-form-dropdown
                            label="reasons for cancellation"
                            vLabel="reference_value_text"
                            v-model="modals.cancellation.data.reason_id"
                            required
                            :reduce="option => option.id"
                            :options="modals.cancellation.reasons">
                        </gofix-form-dropdown>
                        <gofix-form-input-textarea
                            label="remark"
                            class="h-100"
                            v-model="modals.cancellation.data.remark">
                        </gofix-form-input-textarea>
                        <gofix-attachment-area v-model="modals.cancellation.data.files" multiple></gofix-attachment-area>
                        <b-button-group class="d-block text-right">
                            <gofix-button label="SUBMIT" @click="updateOrderCancellation" :loading="modals.cancellation.loading" noBorder></gofix-button>
                        </b-button-group>
                    </b-form>
                </b-col>
            </b-row>
        </b-modal>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    const ViewerImage = () => import('../plugins/ViewerImage.vue')
    import { filters } from '@/_filterVar.js'
    import moment from 'moment';
    import WorkFindings from './service-report/work-findings.vue';
    import GroupServiceReport from './service-report/group-service-report';
    export default {
        name: 'service-report',
        components: {
            ViewerImage,
            WorkFindings,
            GroupServiceReport
        },
        data () {
            return {
                tableConfig:{
                    name: 'tableJobListServiceReport',
                    controls:{
                        create: false
                    },
                    filter: JSON.parse(JSON.stringify(filters['job_list_service_report'])),
                    page: 1,
                    limit: 100,
                    total: 0,
                    sortColumn: null,
                    sortDirection: null,
                    fields: [
                        {
                            key: 'tag_name',
                            label: 'Equipment',
                            isActive: 1,
                            isFilter: true,
                            thStyle: "width:200px",
                            with:200,
                            sorting: false,
                        },
                        {
                            key: 'location',
                            label: 'Location',
                            thClass: 'text-left td-description',
                            tdClass: 'text-left td-description',
                            isActive: 1,
                            isFilter: true,
                            thStyle: "width:auto",
                            with:null,
                            sorting: false,
                        },
                        {
                            key: 'planned_date',
                            label: 'Planned Date',
                            isActive: 1,
                            isFilter: true,
                            thStyle: "width:180px",
                            with:180,
                            sorting: false,
                        },
                        {
                            key: 'expiry_date',
                            label: 'Expiry Date',
                            isActive: 1,
                            isFilter: true,
                            thStyle: "width:180px",
                            with:180,
                            sorting: false,
                        },
                        {
                            key: 'job_status',
                            label: 'Status',
                            isActive: 1,
                            isFilter: true,
                            thStyle: "width:180px",
                            with:180,
                            sorting: false,
                        },
                        {
                            key: 'name_checklist',
                            label: 'Checklist',
                            isActive: 1,
                            isFilter: true,
                            thStyle: "width:250px",
                            with:250,
                            sorting: false,
                        },
                    ]
                },
                tableItems: [],
                action_taken_del_ids: [],
                action_taken : {
                    description : '',
                    remark_type : 'OrderActionTaken',
                    attachments : []
                },
                imgActionTakenAction : {
                    photos : [],
                    delete : []
                },
                imgActionTaken : null,
                work_finding_del_ids: [],
                work_finding : {
                    description : '',
                    remark_type : 'OrderWorkFinding',
                    attachments : []
                },
                imgWorkFindingAction : {
                    photos : [],
                    delete : []
                },
                imgWorkFinding : null,
                isAction : false,
                attachments_show_modal: [],
                modals:{
                    cancellation:{
                        open: false,
                        loading: false,
                        data: {
                            id: null,
                            remark: null,
                            reason_id: null,
                            old_files:[],
                            new_files:[],
                        },
                        reasons: []
                    }
                },
                icons: {
                    'application': {
                        'word': {
                            'img': 'word.png',
                            'svg': '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.0223 5.07305L11.2395 1.29023C11.134 1.18477 10.9916 1.125 10.8422 1.125H3.375C3.06387 1.125 2.8125 1.37637 2.8125 1.6875V16.3125C2.8125 16.6236 3.06387 16.875 3.375 16.875H14.625C14.9361 16.875 15.1875 16.6236 15.1875 16.3125V5.47207C15.1875 5.32266 15.1277 5.17852 15.0223 5.07305ZM13.8902 5.73047H10.582V2.42227L13.8902 5.73047ZM13.9219 15.6094H4.07812V2.39062H9.38672V6.1875C9.38672 6.3833 9.4645 6.57109 9.60296 6.70954C9.74141 6.848 9.9292 6.92578 10.125 6.92578H13.9219V15.6094ZM9.28301 8.29688H8.71699C8.62031 8.29688 8.53594 8.36191 8.51309 8.45684L7.63945 11.9531L6.8291 8.46035C6.80625 8.36543 6.72187 8.29688 6.62344 8.29688H6.00117C5.96884 8.29693 5.93695 8.3044 5.90795 8.31871C5.87896 8.33303 5.85364 8.3538 5.83395 8.37945C5.81425 8.40509 5.8007 8.43491 5.79434 8.46661C5.78798 8.49831 5.78898 8.53105 5.79727 8.5623L7.10156 13.4139C7.12617 13.5053 7.21055 13.5703 7.30547 13.5703H7.86797C7.96289 13.5703 8.04727 13.507 8.07188 13.4139L9 9.95098L9.92812 13.4139C9.95273 13.5053 10.0371 13.5703 10.132 13.5703H10.691C10.7859 13.5703 10.8703 13.507 10.8949 13.4139L12.2027 8.5623C12.2109 8.53105 12.2119 8.49834 12.2055 8.46667C12.1991 8.43499 12.1856 8.4052 12.1659 8.37958C12.1462 8.35396 12.1209 8.33318 12.0919 8.31885C12.063 8.30451 12.0311 8.29699 11.9988 8.29688H11.373C11.2746 8.29688 11.1902 8.36543 11.1674 8.46035L10.3623 11.9602L9.48691 8.45684C9.46406 8.36191 9.37969 8.29688 9.28301 8.29688Z" fill="#666666"/></svg>'
                        },
                        'excel': {
                            'img': 'excel.png',
                            'svg': '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.0297 6.76406L14.9859 1.72031C14.8453 1.57969 14.6555 1.5 14.4562 1.5H4.5C4.08516 1.5 3.75 1.83516 3.75 2.25V21.75C3.75 22.1648 4.08516 22.5 4.5 22.5H19.5C19.9148 22.5 20.25 22.1648 20.25 21.75V7.29609C20.25 7.09687 20.1703 6.90469 20.0297 6.76406ZM18.5203 7.64062H14.1094V3.22969L18.5203 7.64062ZM18.5625 20.8125H5.4375V3.1875H12.5156V8.25C12.5156 8.51107 12.6193 8.76145 12.8039 8.94606C12.9885 9.13066 13.2389 9.23438 13.5 9.23438H18.5625V20.8125ZM12.0492 13.5961L10.6008 11.1961C10.5492 11.1117 10.4578 11.0602 10.3594 11.0602H9.45938C9.40547 11.0602 9.35391 11.0742 9.30938 11.1047C9.17813 11.1867 9.13828 11.3602 9.22266 11.4937L11.1516 14.55L9.19687 17.6625C9.17032 17.7052 9.15565 17.7542 9.15438 17.8045C9.15312 17.8547 9.1653 17.9044 9.18968 17.9484C9.21405 17.9923 9.24973 18.029 9.29303 18.0546C9.33632 18.0801 9.38566 18.0937 9.43594 18.0938H10.2445C10.343 18.0938 10.432 18.0422 10.4836 17.9602L11.9531 15.5812L13.4133 17.9578C13.4648 18.0422 13.5562 18.0914 13.6523 18.0914H14.5312C14.5852 18.0914 14.6367 18.075 14.6836 18.0469C14.8148 17.9625 14.8523 17.7891 14.768 17.6578L12.7992 14.6016L14.7984 11.4961C14.8255 11.4535 14.8407 11.4045 14.8423 11.3541C14.844 11.3037 14.8322 11.2537 14.808 11.2095C14.7838 11.1652 14.7482 11.1282 14.7049 11.1024C14.6616 11.0765 14.6122 11.0628 14.5617 11.0625H13.725C13.6266 11.0625 13.5352 11.1141 13.4836 11.1984L12.0492 13.5961Z" fill="#666666"/></svg>'
                        },
                        'pdf': {
                            'img': 'pdf.png',
                            'svg': '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.33926 10.0969L9.34453 10.0723C9.44648 9.65215 9.5748 9.12832 9.47461 8.65371C9.40781 8.2793 9.13184 8.1334 8.89629 8.12285C8.61855 8.11055 8.3707 8.26875 8.30918 8.49902C8.19316 8.9209 8.29688 9.49746 8.48672 10.2322C8.24766 10.8018 7.86621 11.6297 7.58672 12.1219C7.06641 12.3908 6.36855 12.8057 6.26484 13.3295C6.24375 13.4262 6.26836 13.5492 6.32637 13.66C6.39141 13.783 6.49512 13.8779 6.61641 13.9236C6.66914 13.943 6.73242 13.9588 6.80625 13.9588C7.11563 13.9588 7.6166 13.7092 8.28457 12.5631C8.38652 12.5297 8.49199 12.4945 8.59395 12.4594C9.07207 12.2977 9.56777 12.1289 10.016 12.0533C10.5117 12.3188 11.076 12.4893 11.4592 12.4893C11.8389 12.4893 11.9883 12.2643 12.0445 12.1289C12.143 11.8916 12.0955 11.5928 11.9355 11.4328C11.7035 11.2043 11.1393 11.1445 10.2604 11.2535C9.82793 10.9898 9.54492 10.6313 9.33926 10.0969ZM7.41094 12.767C7.1666 13.1221 6.98203 13.2996 6.88184 13.377C6.99961 13.1607 7.22988 12.9322 7.41094 12.767ZM8.95078 8.62734C9.04219 8.78379 9.02988 9.25664 8.95957 9.4957C8.87344 9.1459 8.86113 8.6502 8.91211 8.59219C8.92617 8.59395 8.93848 8.60449 8.95078 8.62734ZM8.92266 10.7455C9.11074 11.0707 9.34805 11.3502 9.60996 11.5576C9.23027 11.6438 8.88398 11.7861 8.57461 11.9127C8.50078 11.9426 8.42871 11.9725 8.3584 12.0006C8.59219 11.577 8.7873 11.0971 8.92266 10.7455ZM11.6578 11.8969C11.6596 11.9004 11.6613 11.9057 11.6508 11.9127H11.6473L11.6438 11.918C11.6297 11.9268 11.4855 12.0111 10.865 11.7668C11.5787 11.7334 11.6561 11.8951 11.6578 11.8969ZM15.0223 5.07305L11.2395 1.29023C11.134 1.18477 10.9916 1.125 10.8422 1.125H3.375C3.06387 1.125 2.8125 1.37637 2.8125 1.6875V16.3125C2.8125 16.6236 3.06387 16.875 3.375 16.875H14.625C14.9361 16.875 15.1875 16.6236 15.1875 16.3125V5.47207C15.1875 5.32266 15.1277 5.17852 15.0223 5.07305ZM13.8902 5.73047H10.582V2.42227L13.8902 5.73047ZM13.9219 15.6094H4.07812V2.39062H9.38672V6.1875C9.38672 6.3833 9.4645 6.57109 9.60296 6.70954C9.74141 6.848 9.9292 6.92578 10.125 6.92578H13.9219V15.6094Z" fill="#666666"/></svg>'
                        },
                    },
                    'image': {
                        'img': 'image.png',
                        'svg': '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.72246 8.94902L8.35488 10.6928L7.63242 9.77168C7.61927 9.75487 7.60246 9.74128 7.58327 9.73193C7.56409 9.72258 7.54302 9.71772 7.52168 9.71772C7.50034 9.71772 7.47927 9.72258 7.46009 9.73193C7.4409 9.74128 7.42409 9.75487 7.41094 9.77168L5.65664 12.0076C5.64041 12.0283 5.63034 12.0532 5.62758 12.0794C5.62482 12.1056 5.62948 12.132 5.64104 12.1557C5.65259 12.1793 5.67056 12.1992 5.69291 12.2132C5.71525 12.2271 5.74106 12.2344 5.76738 12.2344H12.2344C12.3521 12.2344 12.4172 12.099 12.3451 12.0076L9.9457 8.94902C9.93237 8.93219 9.91541 8.91859 9.89608 8.90924C9.87675 8.89989 9.85555 8.89503 9.83408 8.89503C9.81261 8.89503 9.79142 8.89989 9.77209 8.90924C9.75276 8.91859 9.73579 8.93219 9.72246 8.94902ZM6.32812 7.76953C6.32812 7.95601 6.4022 8.13485 6.53407 8.26672C6.66593 8.39858 6.84477 8.47266 7.03125 8.47266C7.21773 8.47266 7.39657 8.39858 7.52843 8.26672C7.6603 8.13485 7.73438 7.95601 7.73438 7.76953C7.73438 7.58305 7.6603 7.40421 7.52843 7.27235C7.39657 7.14049 7.21773 7.06641 7.03125 7.06641C6.84477 7.06641 6.66593 7.14049 6.53407 7.27235C6.4022 7.40421 6.32812 7.58305 6.32812 7.76953ZM15.0223 5.07305L11.2395 1.29023C11.134 1.18477 10.9916 1.125 10.8422 1.125H3.375C3.06387 1.125 2.8125 1.37637 2.8125 1.6875V16.3125C2.8125 16.6236 3.06387 16.875 3.375 16.875H14.625C14.9361 16.875 15.1875 16.6236 15.1875 16.3125V5.47207C15.1875 5.32266 15.1277 5.17852 15.0223 5.07305ZM13.8902 5.73047H10.582V2.42227L13.8902 5.73047ZM13.9219 15.6094H4.07812V2.39062H9.38672V6.1875C9.38672 6.3833 9.4645 6.57109 9.60296 6.70954C9.74141 6.848 9.9292 6.92578 10.125 6.92578H13.9219V15.6094Z" fill="#666666"/></svg>'
                    },
                    'text': {
                        'img': 'notepad.png',
                        'svg': '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.0297 6.76406L14.9859 1.72031C14.8453 1.57969 14.6555 1.5 14.4562 1.5H4.5C4.08516 1.5 3.75 1.83516 3.75 2.25V21.75C3.75 22.1648 4.08516 22.5 4.5 22.5H19.5C19.9148 22.5 20.25 22.1648 20.25 21.75V7.29609C20.25 7.09687 20.1703 6.90469 20.0297 6.76406ZM18.5203 7.64062H14.1094V3.22969L18.5203 7.64062ZM18.5625 20.8125H5.4375V3.1875H12.5156V8.25C12.5156 8.51107 12.6193 8.76145 12.8039 8.94606C12.9885 9.13066 13.2389 9.23438 13.5 9.23438H18.5625V20.8125Z" fill="#666666"/><path d="M6.75 18H13.75V16.75H6.75V18ZM6.75 10.5V11.75H17.25V10.5H6.75ZM6.75 14.875H17.25V13.625H6.75V14.875Z" fill="#666666"/></svg>'
                    },
                    'inode': 'none'
                },
            }
        },
        created(){
            this.getReasonForCancellation();
        },
        computed:{
            ...mapGetters({
                OrderJobList: 'RunsheetController/OrderJobList',
                Item: 'OrderController/Item',
                IsReadOnly: 'OrderController/IsReadOnly',
            })
        },
        filters:{
            countCompleted(data){
                let countItem = 0;
                for(let item of data){
                    if(item.job_status === "Completed"){
                        countItem++;
                    }
                }
                return countItem;
            },
            iconFile(val, icons, is_svg = false) {
                let path = 'img/';
                let type_show = 'img';
                let extension = '';
                let type = val.type || val.image_content_type;

                if(is_svg) {
                    path = '';
                    type_show = 'svg';
                }
                if(val.type) extension = val.name.split('.')[1];

                let arrTemp = type.split('/');
                if(arrTemp && arrTemp.length == 2) {
                    let type = arrTemp[0];
                    if(!extension) extension = arrTemp[1];

                    if(type == 'application' || type == 'inode' || type == 'text') {
                        let key = 'pdf';
                        if(['docx', 'doc', 'vnd.openxmlformats-officedocument.wordprocessingml.document', 'msword'].includes(arrTemp[1])) key = 'word';
                        if(['xls', 'xlsx', 'vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'vnd.ms-excel'].includes(arrTemp[1])) key = 'excel';
                        if(['zip', 'x-empty', 'plain'].includes(arrTemp[1])) {
                            let extension = val.image_file_name.split('.')[1];
                            if(['doc', 'docx'].includes(extension)) key = 'word';
                            if(['xls', 'xlsx', 'csv'].includes(extension)) key = 'excel';
                        }
                        return `${path}${icons['application'][key][type_show]}`;
                    }

                    return `${path}${icons[type][type_show]}`;
                }
            }
        },
        watch: {
            imgWorkFinding (val,old) {
                if(val) {
                    val.forEach(file => {
                        if(file.type!='image/jpeg' && file.type!='image/png' && file.type!='image/gif' ) {
                            this.$alertNotification("File format is incorrect. Please select a .jpeg, .jpg, .png, .gif file!", "warning");
                            return;
                        }
                        file.moment = moment().valueOf();
                        let data = {
                            moment : moment().valueOf(),
                            url: {
                                original: URL.createObjectURL(file),
                                medium: URL.createObjectURL(file),
                                thumb: URL.createObjectURL(file)
                            }
                        }
                        this.imgWorkFindingAction.photos.push(file);
                        this.work_finding.attachments.push(data);
                    });
                }
            },
            imgActionTaken (val,old) {
                if(val) {
                    val.forEach(file => {
                        if(file.type!='image/jpeg' && file.type!='image/png'&& file.type!='image/gif' ) {
                            this.$alertNotification("File format is incorrect. Please select a .jpeg, .jpg, .png, .gif file!", "warning");
                            return;
                        }
                        file.moment = moment().valueOf();
                        let data = {
                            moment : moment().valueOf(),
                            url: {
                                original: URL.createObjectURL(file),
                                medium: URL.createObjectURL(file),
                                thumb: URL.createObjectURL(file)
                            }
                        }
                        this.imgActionTakenAction.photos.push(file);
                        this.action_taken.attachments.push(data);
                    });
                }
            },
        },
        methods: {
            async previewFile(attachment) {
                const link = document.createElement('a');
                var path = this.$router.resolve({name: 'FilePreview', params: {file_id: attachment.id}}).href;
                link.href= path;
                link.setAttribute('target', '_blank');
                document.body.appendChild(link);
                link.click();
            },
            checkShowImage(val) {
                if(!val) return false;
                let arrTemp = val.split('/');
                if(!arrTemp || arrTemp.length < 2 || arrTemp[0] != 'image' ) return false;
                return true;
            },
            checkShowIcon(val) {
                if(!val) return false;
                let arrTemp = val.split('/');
                if(!arrTemp || arrTemp.length < 2 || !this.icons[arrTemp[0]]) return false;
                return true;
            },
            modalThumb(attachments) {
                this.attachments_show_modal = []
                if(attachments) {
                    this.attachments_show_modal = attachments
                }
                this.$refs['modalThumb'].show()
            },
            async updateActionTaken(){
                this.isAction = true;
                if(this.action_taken_del_ids.length > 0) {
                    this.action_taken.attachment_del_ids = this.action_taken_del_ids;
                }
                await this.$store.dispatch("OrderController/updateRemarksOrder", {data : this.action_taken , order_id : this.Item.id , action : this.imgActionTakenAction })
                    .then(result => {
                        this.imgActionTakenAction =  {
                            photos : [],
                            delete : []
                        }
                        if(this.action_taken.attachment_del_ids){
                            delete this.action_taken.attachment_del_ids
                        }
                        this.$alertNotification(this.$notificationV2('editing', 'order'));
                        this.$refs['modal-edit-action-taken'].hide()
                    }).catch(error => {
                        this.isAction = false;
                    })
            },
            editActionTaken(){
                this.isAction = false;
                let data = JSON.parse(JSON.stringify(this.Item));
                if(data.action_taken) {
                    this.action_taken = data.action_taken;
                } else {
                    this.action_taken.attachments = [];
                    this.action_taken.description = '';
                }
                this.$refs['modal-edit-action-taken'].show()
            },
            async updateWorkFinding(){
                this.isAction = true;
                if(this.work_finding_del_ids.length > 0) {
                    this.work_finding.attachment_del_ids = this.work_finding_del_ids;
                }
                await this.$store.dispatch("OrderController/updateRemarksOrder", {data : this.work_finding , order_id : this.Item.id, action : this.imgWorkFindingAction })
                    .then(result => {
                        this.imgWorkFindingAction =  {
                            photos : [],
                            delete : []
                        };
                        if(this.work_finding.attachment_del_ids){
                            delete this.work_finding.attachment_del_ids
                        }
                        this.$alertNotification(this.$notificationV2('editing', 'order'));
                        this.$refs['modal-edit-work-finding'].hide()
                    }).catch(error => {
                        this.isAction = false;
                    })
            },
            editWorkFinding(){
                this.isAction = false;
                let data = JSON.parse(JSON.stringify(this.Item));
                if(data.work_finding) {
                    this.work_finding = data.work_finding;
                } else {
                    this.work_finding.attachments = [];
                    this.work_finding.description = '';
                }
                this.$refs['modal-edit-work-finding'].show()
            },
            deleteImgWorkFinding(img){
                if(img.moment){
                    this.work_finding.attachments = this.work_finding.attachments.filter(item => item.moment != img.moment);
                    this.imgWorkFindingAction.photos = this.imgWorkFindingAction.photos.filter(item => item.moment != img.moment)
                }
                else {
                    this.work_finding_del_ids.push(img.id);
                    this.work_finding.attachments = this.work_finding.attachments.filter(item => !this.work_finding_del_ids.includes(item.id));
                }
            },
            deleteImgActionTaken(img){
                if(img.moment){
                    this.action_taken.attachments = this.action_taken.attachments.filter(item => item.moment != img.moment);
                    this.imgActionTakenAction.photos = this.imgActionTakenAction.photos.filter(item => item.moment != img.moment)
                }
                else {
                    this.action_taken_del_ids.push(img.id);
                    this.action_taken.attachments = this.action_taken.attachments.filter(item => item.id != img.id);
                }
            },
            async getTableData(callback){
                const { tableRequest , resolve,reject } = await callback();
                tableRequest.filter.order_id.value = this.$route.params.id;
                this.$store.dispatch("RunsheetController/getJoblist",tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        console.log(err);
                        reject();
                    });
            },
            getReasonForCancellation(){
                this.$store.dispatch("ReferenceController/getItems", {
                    page: 1,
                    limit: -1,
                    sortColumn: "reference_value_text",
                    sortDirection: "DESC",
                    isCMS:0,
                    filter:{
                        reference_type:"Reasons For Cancellation",
                        contract_id: this.Item ? this.Item.contract_id : 0
                    }
                })
                    .then(response => {
                        this.modals.cancellation.reasons = response.items;
                    })
                    .catch(err => {
                        this.modals.cancellation.reasons = [];
                    })
            },
            openCancellationModal(){
                this.modals.cancellation.data.id = this.Item.order_cancellation ? this.Item.order_cancellation.id : null;
                this.modals.cancellation.data.remark = this.Item.order_cancellation ? this.Item.order_cancellation.remark : null;
                this.modals.cancellation.data.reason_id = this.Item.order_cancellation ? this.Item.order_cancellation.reason_id : null;
                this.modals.cancellation.data.files = this.Item.order_cancellation ? this.Item.order_cancellation.attachments : [];
                this.modals.cancellation.open = true;
            },
            updateOrderCancellation(){
                if(this.modals.cancellation.loading) return;
                this.modals.cancellation.loading = true;
                this.$store.dispatch("OrderController/updateOrderCancellation",this.modals.cancellation.data)
                    .then(response => {
                        this.$emit('reloadorder');
                        this.modals.cancellation.loading = false;
                        this.modals.cancellation.open = false;
                    })
                    .catch(err => {
                        this.modals.cancellation.loading = false;
                    })
            },
            async downloadFile(attachment) {
                let url = attachment.url.original;
                let params = {};
                params.url = url;
                params.image_file_name = attachment.image_file_name;

                 await this.$store.dispatch("FileDownloadController/getFile", params)
                .then(response => {
                })
                .catch(err => {
                    this.$alertNotification("Can not download file", "danger");
                    console.log(err);
                })
            },
        }
    }
</script>
